import { render, staticRenderFns } from "./ArchivedSpotType.vue?vue&type=template&id=0154ce0a&"
import script from "./ArchivedSpotType.vue?vue&type=script&lang=js&"
export * from "./ArchivedSpotType.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedSpotType.vue?vue&type=style&index=0&id=0154ce0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports